<div 
   class="tw-relative tw-w-full tw-flex tw-flex-col lg:tw-items-center lg:tw-justify-center tw-max-w-xl lg:tw-max-w-md tw-mx-auto tw-px-4" 
   [ngClass]="{ 
      'lg:tw-min-h-screen lg:tw-pb-6': !isInsidePopup(),
      'lg:tw-min-h-full xl:tw-px-6 tw-pt-10 xl:tw-py-12': isInsidePopup() 
   }"
>
   @if (isRedirecting()) {
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-min-h-[300px] tw-w-full">
         <svg class="tw-animate-spin tw-h-10 tw-w-10 tw-text-brand-green" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
         </svg>
         <p class="tw-mt-4 tw-text-content-blue tw-font-medium">Redirecting you to the platform...</p>
      </div>
   } @else {
      @if (headerText()) {
         <h2 
            class="tw-text-content-blue tw-w-full tw-text-2xl lg:tw-text-3xl"
            [ngClass]="{ 
               'lg:tw-text-center lg:tw-font-normal tw-mb-8 lg:tw-mb-10': !isInsidePopup(),
               'tw-mb-2 tw-text-start tw-font-medium': isInsidePopup() 
            }"
            [innerHTML]="headerText()">
         </h2>
      }

      @if (subheaderText()) {
         <p class="tw-text-content-blue/80 tw-text-sm/snug tw-w-full text-start tw-mb-6 tw-text-pretty">
            {{ subheaderText() }}
         </p>
      }

      <div class="tw-w-full tw-flex tw-flex-col tw-gap-3 lg:tw-gap-4">
         <app-google-login buttonText="Login via Google" [isGoogleBtnInsidePopup]="isInsidePopup()"></app-google-login>
         <app-apple-login buttonText="Login via Apple" [isAppleBtnInsidePopup]="isInsidePopup()"></app-apple-login>
      </div>

      @if (isEmailFormVisible()) {
         <div class="tw-w-full tw-flex tw-items-center tw-mt-8 tw-mb-6">
            <div class="tw-flex-1 tw-h-px tw-bg-gray-200"></div>
            <span class="tw-px-4 tw-text-sm tw-text-gray-700 tw-uppercase tw-tracking-wider">OR</span>
            <div class="tw-flex-1 tw-h-px tw-bg-gray-200"></div>
         </div>

         <form [formGroup]="loginForm" (ngSubmit)="login()" class="tw-grid tw-w-full lg:tw-gap-1">
            <div class="tw-flex tw-flex-col tw-w-full tw-gap-1">
               <label for="email" class="tw-block tw-text-[#475569] tw-text-sm">Email Address</label>
               <input 
                  class="tw-block tw-min-w-0 tw-px-4 tw-grow tw-rounded-base tw-text-sm tw-h-12 tw-border tw-border-solid tw-outline-none placeholder:tw-text-[#CBD5E1]" 
                  [class.tw-border-red-500]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                  [class.focus:tw-border-red-500]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                  [class.tw-border-gray-300]="!(loginForm.get('email')?.invalid && loginForm.get('email')?.touched)"
                  [class.focus:tw-border-brand-blue]="!(loginForm.get('email')?.invalid && loginForm.get('email')?.touched)"
                  type="email" 
                  formControlName="email"
                  id="email" 
                  placeholder="name@example.com"
               >
               <!-- Reserve space for error messages avoiding layout shifts -->
               <div class="tw-min-h-4">
                  @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
                     @if (loginForm.get('email')?.hasError('required')) {
                        <small class="tw-block tw-text-xs/snug tw-text-red-500 tw-leading-tight">Email Address is required.</small>
                     } @else if (loginForm.get('email')?.hasError('email') || loginForm.get('email')?.hasError('pattern')) {
                        <small class="tw-block tw-text-xs/snug tw-text-red-500 tw-leading-tight">Please enter a valid email address.</small>
                     }
                  }
               </div>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full tw-gap-1">
               <div class="tw-flex tw-items-center tw-justify-between">
                  <label for="password" class="tw-block tw-text-[#475569] tw-text-sm">Password</label>
                  <a 
                     routerLink="/authentication/forgot-password" 
                     [queryParams]="authQueryParams()"
                     (click)="handleLinkClick($event, 'forgot-password')"
                     class="tw-text-xs tw-text-brand-green tw-no-underline hover:tw-underline"
                  >
                     Forgot Password?
                  </a>
               </div>
               <div class="tw-flex tw-items-center tw-justify-between tw-pe-4 tw-rounded-base tw-border tw-border-solid tw-overflow-hidden tw-transition-colors"
                  [class.tw-border-red-500]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                  [class.focus-within:tw-border-red-500]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                  [class.tw-border-gray-300]="!(loginForm.get('password')?.invalid && loginForm.get('password')?.touched)"
                  [class.focus-within:tw-border-brand-blue]="!(loginForm.get('password')?.invalid && loginForm.get('password')?.touched)">
                  <input 
                     class="tw-block tw-min-w-0 tw-px-4 tw-grow tw-h-12 tw-text-sm tw-rounded-base tw-border-0 tw-outline-none placeholder:tw-text-[#CBD5E1]" 
                     [type]="showPassword() ? 'text' : 'password'" 
                     formControlName="password"
                     id="password" 
                     placeholder="•••••••••••"
                  >

                  <button type="button" (click)="togglePasswordVisibility()" class="tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-600 tw-outline-none tw-flex tw-items-center tw-justify-center" aria-label="Toggle password visibility">
                     @if (showPassword()) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                           <g fill="none" stroke="currentColor" stroke-width="1.5">
                              <path d="M21.544 11.045c.304.426.456.64.456.955 0 .316-.152.529-.456.955C20.178 14.871 16.689 19 12 19c-4.69 0-8.178-4.13-9.544-6.045C2.152 12.529 2 12.315 2 12c0-.316.152-.529.456-.955C3.822 9.129 7.311 5 12 5c4.69 0 8.178 4.13 9.544 6.045Z"/>
                              <path d="M15 12a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z"/>
                           </g>
                        </svg>
                     } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                           <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5">
                              <path stroke-linejoin="round" d="M19.439 15.439a19.5 19.5 0 0 0 2.105-2.484c.304-.426.456-.64.456-.955 0-.316-.152-.529-.456-.955C20.178 9.129 16.689 5 12 5c-.908 0-1.77.155-2.582.418m-2.67 1.33c-2.017 1.36-3.506 3.195-4.292 4.297-.304.426-.456.64-.456.955 0 .316.152.529.456.955C3.822 14.871 7.311 19 12 19c1.99 0 3.765-.744 5.253-1.747"/>
                              <path d="M9.858 10A2.929 2.929 0 1 0 14 14.142"/>
                              <path stroke-linejoin="round" d="m3 3 18 18"/>
                           </g>
                        </svg>
                     }
                  </button>
               </div>
               <!-- Reserve space for error messages avoiding layout shifts -->
               <div class="tw-min-h-4">
                  @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
                     @if (loginForm.get('password')?.hasError('required')) {
                        <small class="tw-block tw-text-xs/snug tw-text-red-500 tw-leading-tight">Password is required.</small>
                     }
                  }
               </div>
            </div>

            @if (errorMessage()) {
               <div class="tw-w-full tw-bg-red-50 tw-border tw-border-red-200 tw-text-red-600 tw-px-4 tw-py-2 tw-rounded-base tw-text-sm tw-text-center tw-mb-4">
                  {{ errorMessage() }}
               </div>
            }

            <button type="submit" [disabled]="isSubmitting() || loginForm.invalid" class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-brand-green tw-text-white tw-border-none tw-rounded-base tw-h-12 hover:tw-bg-opacity-80 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed">
               @if (isSubmitting()) {
                  <svg class="tw-animate-spin tw-h-5 tw-w-5 tw-text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                     <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                     <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Logging in...
               } @else {
                  Login
               }
            </button>
         </form>
      } @else {
         <div class="tw-w-full tw-flex tw-items-center tw-my-6">
            <div class="tw-flex-1 tw-h-px tw-bg-gray-200"></div>
            <span class="tw-px-4 tw-text-sm tw-text-gray-400 tw-uppercase tw-tracking-wider">OR</span>
            <div class="tw-flex-1 tw-h-px tw-bg-gray-200"></div>
         </div>

         <button 
            type="button" 
            (click)="toggleEmailForm()" 
            class="tw-w-full tw-bg-white tw-text-brand-blue tw-border tw-border-solid tw-border-brand-blue tw-rounded-base tw-h-12 hover:tw-bg-gray-50 tw-transition-all tw-flex tw-items-center tw-justify-center tw-gap-3 tw-font-medium"
         >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
               <g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5">
               <path d="m2 6 6.913 3.917c2.549 1.444 3.625 1.444 6.174 0L22 6"/>
               <path d="M2.016 13.476c.065 3.065.098 4.598 1.229 5.733 1.131 1.136 2.705 1.175 5.854 1.254 1.94.05 3.862.05 5.802 0 3.149-.079 4.723-.118 5.854-1.254 1.131-1.135 1.164-2.668 1.23-5.733.02-.986.02-1.966 0-2.952-.066-3.065-.099-4.598-1.23-5.733-1.131-1.136-2.705-1.175-5.854-1.254a115 115 0 0 0-5.802 0c-3.149.079-4.723.118-5.854 1.254-1.131 1.135-1.164 2.668-1.23 5.733a69 69 0 0 0 0 2.952Z"/>
               </g>
            </svg>
            Login with Email
         </button>
      }

      <p class="tw-text-center tw-text-xs xl:tw-text-sm tw-mt-3 tw-mb-0">
         Don't have an account? 
         <a 
            [routerLink]="isInsidePopup() ? null : '/authentication/register'" 
            [queryParams]="authQueryParams()" 
            (click)="handleLinkClick($event, 'signup')"
            class="tw-text-brand-green tw-no-underline hover:tw-underline hover:tw-underline-offset-2 tw-font-medium tw-cursor-pointer"
         >
            Sign Up For Free
         </a>
      </p>

      <p class="tw-mb-3 tw-text-gray-600 tw-text-center tw-text-[.625rem] lg:tw-text-xs tw-mt-8 lg:tw-mt-0 lg:tw-absolute lg:tw-bottom-0 lg:tw-w-full lg:tw-left-0">
         By continuing, you agree to our <a routerLink="/terms-of-use" (click)="handleLinkClick($event, 'legal')" class="tw-text-gray-600 tw-underline-offset-2 tw-font-medium">Terms</a> & <a routerLink="/privacy-policy" (click)="handleLinkClick($event, 'legal')" class="tw-text-gray-600 tw-underline-offset-2 tw-font-medium">Privacy Policy</a>
      </p>
   }
</div>
